const getTranslations = fetch(`/Umbraco/Api/MetadataCatalogueSearchResults/GetDictionaryTranslations`)
    .then(response => {
        if (!response.ok) {
            throw new Error(`Error trying to retrieve the translations: ${response.status}`);
        }

        return response.json();
    })
    .catch(error => console.error("Couldn't fetch the translation data: ", error));

export {getTranslations}
